import { createContext, useContext } from 'react';

const AppContext = createContext<any>(undefined);

export const useAppContext = () => useContext(AppContext);
export default AppContext;
